module.exports = __webpack_public_path__ + "static/media/woman.6acdee87.jpg";